import {useState} from "react";
import {PropsWithChildren} from "react";
import {ThemeProvider} from "styled-components";
import {useServices} from "../../react-hooks/use-services.hook";
import {FlexContainerBox} from "../../themes/architecture/css-helpers/flex";
import {BgBox} from "./boxes/bg.box";
import {Label} from "./boxes/label";

export const ThemeSwitcher: React.FC<PropsWithChildren> = (props) => {
    const services = useServices();
    const [guid] = useState(services.tools.getGuid());
    const [theme, setTheme] = useState("content");

    function getTheme(key: string) {
        if (key === "shell") {
            return services.theme.currentTheme;
        }
        if (key === "content") {
            return services.theme.mainContentTheme;
        }
        return services.theme.mainContentTheme;
    }

    return <div style={{margin: "5px 2rem", border: "1px dashed black"}}>
        <FlexContainerBox>
            <h3>Theme: </h3>
            {["shell", "content"].map((th) =>
                <div key={th} style={{margin: "5px"}}>
                    <input
                        type="radio" name={"theme_" + guid} id={"theme_" + guid + "_" + th} value={th}
                        checked={th === theme}
                        onChange={() => {
                            setTheme(th); 
                        }}
                    />
                    <Label htmlFor={"theme_" + guid + "_" + th}>{th}</Label>
                </div>
            )}
        </FlexContainerBox>

        <ThemeProvider theme={getTheme(theme)}>
            <BgBox>
                {props.children}
            </BgBox>
        </ThemeProvider>
    </div>;
};
